export default __webpack_public_path__ + "static/media/design_solution.62b581e7.jpg";